import { getStringWidth } from '~/utils/string';

export function useFieldSizingContent(inputRef: React.ForwardedRef<HTMLInputElement>, classList: Array<string>) {
  // Check if the browser supports the field-sizing content feature
  if (CSS.supports?.('field-sizing', 'content')) {
    return;
  }

  const current = typeof inputRef === 'function' ? null : inputRef?.current;
  if (!current) {
    return;
  }

  current.style.width = `${getStringWidth(current.value, classList)}px`;
}
